import MenuHeader from './MenuHeader';
import { MenuHeaderProps, MenuHeaderValueProps } from './types';

export type { MenuHeaderProps, MenuHeaderValueProps };
export default MenuHeader;
